import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/path-black.svg'


const _withScopeId = n => (_pushScopeId("data-v-22eb23ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full sm:h-[100px] total-balance flex flex-col items-start px-8 py-3" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col sm:flex-row justify-between gap-4 sm:items-center w-full text-start"
}
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-[12px]" }, "Total de dividendos", -1))
const _hoisted_5 = {
  key: 0,
  class: "font-bold text-[28px] text-white"
}
const _hoisted_6 = {
  key: 1,
  class: "font-bold text-[28px] text-white"
}
const _hoisted_7 = { class: "text-[12px] text-white" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col sm:text-right"
}
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-xs" }, "Rentabilidad Total", -1))
const _hoisted_11 = {
  key: 0,
  class: "font-bold text-white"
}
const _hoisted_12 = {
  key: 1,
  class: "font-bold text-white"
}
const _hoisted_13 = { class: "flex flex-col sm:text-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-xs" }, "Rentabilidad Real", -1))
const _hoisted_15 = {
  key: 0,
  class: "font-bold text-white"
}
const _hoisted_16 = {
  key: 1,
  class: "font-bold text-white"
}
const _hoisted_17 = {
  key: 1,
  class: "text-white text-[12px]"
}
const _hoisted_18 = { class: "w-full h-[50px] total-balance view-movement flex items-center justify-center gap-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-black text-[12px]" }, "Ver dividendos", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: ""
}, null, -1))

import { ref, onMounted, computed } from "vue";
import { ShareholderService } from "@/services/shareholder/ShareholderService";
import { shareholderStore } from "@/stores/shareholder";
import { toBadgeFormat, formatNumber } from "@/services/utils";
import { accountStore } from "@/stores/account";

import { FilterType } from "../../services/charts/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'TotalBalanceCard',
  props: {
  customValue: {
    type: Number,
    required: false,
  },
  monthlyData: {
    type: Object,
    required: false,
  },
  filterType: {
    required: true,
  },
},
  setup(__props) {

const props = __props;



const shareholderStr = shareholderStore();
const shareholder = computed(() => shareholderStr.shareholder);
const dividendClp = ref();

const filterTypeSelected = computed(() => props.filterType);

const accountStr = accountStore();
const activeAccount = computed(() => accountStr.activeAccount);

onMounted(async () => {
  try {
    const shareholderService = new ShareholderService();
    const response = await shareholderService.getShareholderDetail(
      shareholder.value.id
    );

    if (response.success) {
      dividendClp.value = response.data.dividendBalanceClp.toString();
    }
  } catch (error) {
    console.error(error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.customValue || _unref(activeAccount) != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (__props.customValue)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString("CLP " + _unref(toBadgeFormat)(__props.customValue)), 1))
                : (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString("CLP  " + _unref(toBadgeFormat)(0)), 1)),
              _createElementVNode("p", _hoisted_7, _toDisplayString(__props.filterType == _unref(FilterType).ByConsolidated
                ? "Acumulado a la fecha"
                : "A la fecha"), 1)
            ]),
            (_unref(filterTypeSelected) === _unref(FilterType).ByYear)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    (__props.monthlyData?.sumTotalProfitability)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_11, _toDisplayString(_unref(formatNumber)(__props.monthlyData?.sumTotalProfitability)) + " % ", 1))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_12, _toDisplayString(_unref(formatNumber)(0)) + " %", 1))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    (__props.monthlyData?.sumRealProfitability)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_15, _toDisplayString(_unref(formatNumber)(__props.monthlyData?.sumRealProfitability)) + " % ", 1))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_16, _toDisplayString(_unref(formatNumber)(0)) + " %", 1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("h1", _hoisted_17, " Seleccione una cuenta para ver más información "))
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_router_link, {
        class: "btn-solicitud",
        "active-class": "font-bold text-green-700",
        to: { name: 'MyDividends' }
      }, {
        default: _withCtx(() => [
          _hoisted_19,
          _hoisted_20
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})